import { Button, ButtonProps, styled } from "@mui/material";
import hexToRgba from "hex-to-rgba";

export function ButtonStyled(props: ButtonProps) {
  const StyledButton = styled((props: ButtonProps) => <Button {...props} />)(({ theme }) => ({
    boxShadow: "none",
    borderRadius: 12,
    fontWeight: 600,
    border:
      props.variant === "outlined"
        ? `1px solid ${hexToRgba(theme.palette.text.primary, 0.5)} !important`
        : "none",
    color: theme.palette.text.primary,
    "&.MuiButton-containedSecondary:hover": {
      filter: "brightness(90%)",
      backgroundColor: theme.palette.secondary.main,
      boxShadow: "none",
    },
    "&.MuiButton-containedPrimary:hover": {
      filter: "brightness(90%)",
      boxShadow: "none",
    },
  }));

  return <StyledButton {...props} />;
}
